export default __webpack_public_path__ + "static/media/Broan@3x.8d7edb9e.png";